import styled from 'styled-components';

export const Layout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: white;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;
